import SpriteSymbol from "../../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "macOSX",
  "use": "macOSX-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"macOSX\"><path d=\"M9 2C5.13 2 2 5.13 2 9s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm3.55 11.48h-.85L9 9.61l-2.7 3.87h-.85L8.57 9 5.45 4.52h.85L9 8.39l2.7-3.87h.85L9.43 9l3.12 4.48z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol